
const tryParseJSON = (key, value) => {
    try {
        return [key, JSON.parse(value)];
    } catch (error) {
        return [key, value];
    }
}
export default (key) => {
    const cookies = new Map(document.cookie.split(';')
            .map(cookie => cookie.trim())
            .map(cookie => cookie.split('='))
            .map(i => tryParseJSON(...i))
        )
    return key ? cookies.get(key) : cookies

}